import { getDetailsOfSummaryData } from '_services/invoiceBillRaiseServices';
import { ButtonHeading, CommonInput } from 'components';
import { BillSummaryDetails } from 'pages/InvoiceBillRaise';
import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StorageService from 'utils/StorageServices/StorageServices';
import { constant } from 'constants/constant';
import Tab from 'components/common/Tab';
import { UserContext } from 'context';
import { ClaimDetailsTabList } from '.';
import { ThankyouModal } from 'modals';
import './invoicing.css'

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const InvoiceDetails = () => {

    const { id } = useParams();
    const { invoiceTableToggle, setInvoiceTableToggle } = useContext(UserContext)

    const query = useQuery();
    const ct = query.get('ct'); // ct = create bill raise parameter

    const location = useLocation();
    const navigate = useNavigate();
    const [isOpenThankyouModal, setIsOpenThankyouModal] = useState(false);

    const [activeTab, setActiveTab] = useState(1);
    const [isDropDownFilter, setIsDropDownFilter] = useState({
        consignor_id: '',
    })

    const [loading, setLoading] = useState(true);
    const [billRaiseDetailsData, setBillRaiseDetailsData] = useState({});

    const callInvoiceDetailsApi = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                billraise_id: id,
            }
            const res = await getDetailsOfSummaryData(object);
            if (res?.responseCode == 200) {
                setBillRaiseDetailsData(res?.data?.billraise);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            // throw error;
        }
    }

    useEffect(() => {
        setIsDropDownFilter((s) => ({
            ...s,
            consignor_id: {
                label: billRaiseDetailsData?.consignor_id?.name,
                value: billRaiseDetailsData?.consignor_id?._id,
            }
        }))
    }, [billRaiseDetailsData?.consignor_id])

    useEffect(() => {
        if (id && StorageService.getCompanyId()) {
            setLoading(true);
            callInvoiceDetailsApi();
        }
    }, [id, StorageService.getCompanyId()])

    const tabProps = {
        tabList: constant.invoiceClaimDetailsTabs,
        callBackTab: (e) => setActiveTab(e),
        activeTab: activeTab,
    };

    const closeHandlerFunction = () => {
        // setInvoiceTableToggle(false);
        const params = new URLSearchParams(location.search);
        params.set('ct', null);
        navigate(`${location.pathname}`); // ?${params.toString()}
    }

    let thankyouModalProps = {
        isOpen: isOpenThankyouModal,
        closeModal: (e) => setIsOpenThankyouModal(!isOpenThankyouModal),
        modalMainClass: "_dashCommon_Modal _smModal",
        callNavigateFunction: closeHandlerFunction,
        closeButtonNotShow: false,
    }

    useEffect(() => {
        if (ct) {
            setIsOpenThankyouModal(true)
            const clear = setTimeout(() => {
                closeHandlerFunction();
                setIsOpenThankyouModal(false);
            }, 3000);
            return () => {
                clearTimeout(clear);
            };
        }
    }, [ct])

    return (
        <>
            <div>
                <ButtonHeading
                    title={"Bill Raise"}
                    Export={false}
                    // ExportSubmit={hello}
                    Print={false}
                    // PrintSubmit={hello}
                    Edit={false}
                // EditSumit={hello}
                />

                <div className="addPr_flBx">
                    <Tab {...tabProps} />

                    {activeTab === 1 &&
                        <>
                            <div className="_fleX_inds _blRaise_fits">
                                <div className="_divForth">
                                    <CommonInput
                                        type="text"
                                        label="Party"
                                        placeholder="Party"
                                        disabled={true}
                                        value={isDropDownFilter?.consignor_id?.label ? isDropDownFilter?.consignor_id?.label : ''}
                                    />
                                </div>
                            </div>

                            <BillSummaryDetails
                                data={billRaiseDetailsData}
                                filterData={isDropDownFilter}
                                callInvoiceDetailsApi={(e) => callInvoiceDetailsApi(e)}
                                claimFieldHide={true}
                            />
                        </>
                    }
                    {activeTab === 2 &&
                        <ClaimDetailsTabList
                            filterData={isDropDownFilter}
                            detailsData={billRaiseDetailsData}
                            callInvoiceDetailsApi={(e) => callInvoiceDetailsApi(e)}
                        />
                    }
                </div>
            </div>

            {isOpenThankyouModal
                && (
                    <ThankyouModal {...thankyouModalProps} />
                )
            }
        </>
    )
}

export default InvoiceDetails